var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 14 7.004 C 14 10.87 10.865 14.003 6.993 14 C 3.13 14 -0.012 10.856 -0 6.975 C 0.012 3.13 3.147 -0.012 7.031 -0 C 10.873 0.012 14 3.147 14 7.004 Z M 7.934 8.635 C 7.934 8.091 7.937 7.548 7.934 7.004 C 7.928 6.487 7.513 6.075 7.01 6.072 C 6.502 6.069 6.075 6.475 6.072 6.993 C 6.066 8.091 6.066 9.187 6.072 10.286 C 6.075 10.581 6.192 10.838 6.437 11.014 C 6.753 11.239 7.092 11.277 7.44 11.09 C 7.776 10.908 7.928 10.613 7.934 10.242 C 7.937 9.702 7.934 9.167 7.934 8.635 Z M 8.021 4.205 C 8.021 3.644 7.563 3.182 7.004 3.182 C 6.443 3.182 5.982 3.641 5.982 4.199 C 5.982 4.766 6.44 5.222 7.013 5.222 C 7.56 5.222 8.021 4.757 8.021 4.205 Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackNew);
export default __webpack_public_path__ + "static/media/black_new.ab64a4e8.svg";
export { ForwardRef as ReactComponent };